import styled from 'styled-components';

import {
  colorBlack900,
  colorPrimaryLighten95,
  colorWhite,
} from 'styles/variables';

export const Button = styled.button`
  display: flex;
  border: none;
  background-color: ${({ selected }) =>
    selected ? colorPrimaryLighten95 : colorWhite};
  outline: 0;
  font-size: 14px;
  line-height: 24px;
  height: 48px;
  letter-spacing: 0.03px;
  transition: color 0.3s;
  z-index: 2;
  align-items: center;
  color: ${colorBlack900};
  padding: 0 16px;
  justify-content: space-between;
  width: 100%;
`;

export const IconWrapper = styled.div`
  margin-left: 16px;
`;
